export enum NavigationFeature {
  Overview = 'Overview',
  SiteSettings = 'SiteSettings',
  OrderFeed = 'OrderFeed',
  ProfilesStrategies = 'ProfilesStrategies',
  PlanAndPrognosis = 'PlanAndPrognosis',
  FieldRegistration = 'FishCheck',
  ScenarioBuilder = 'ScenarioBuilder',
  FeedManagement = 'FeedManagement',
  PowerBi = 'PowerBi',
  SeaCloudFileUpload = 'SeaCloudFileUpload',
  ShrimpDataUpload= 'ShrimpDataUpload',
  FileSharing = 'FileSharing',

  ShrimpProductionSystem = 'ShrimpProductionSystem',
  ShrimpBenchmarkAnalytics = 'ShrimpBenchmarkAnalytics',
  ShrimpSelfService = 'ShrimpSelfService',
  DeliveryBoard = 'DeliveryBoard',
  Playground = 'Playground',
}
